class Accordion2 {
  constructor() {
    const allAccordion = document.querySelectorAll(".accordion-list2");
    allAccordion.forEach(function (current) {
      const allList = current.querySelectorAll(".accordion-single2");
      allList.forEach(function (single) {
        single.addEventListener("click", () => {
          console.log(single.children[1].querySelector("h2").style.cssText);
          single.children[2].classList.toggle("accordion-open");
          if (
            single.children[1].querySelector("h2").style.cssText ===
            "--rotate: 90deg;"
          ) {
            single.children[1]
              .querySelector("h2")
              .style.setProperty("--rotate", "0deg");
          } else {
            single.children[1]
              .querySelector("h2")
              .style.setProperty("--rotate", "90deg");
          }
        });
      });
    });
  }
}

export default Accordion2;
